import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error bender imports are untyped
import defaultAvatar from 'bender-url!../../../../images/default-avatar.png';
// @ts-expect-error js file is not typed
import useMediaQuery from '../../../hooks/useMediaQuery';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavTrigger = ({
  onClick,
  name,
  avatarUrl,
  isOpen
}) => {
  const breakpointName = useMediaQuery('(max-width: 1440px)');
  return /*#__PURE__*/_jsx(Button, {
    "aria-expanded": isOpen,
    "aria-haspopup": "menu",
    "aria-label": I18n.text('learningCenter.faceNav.accessibility.account_menu_trigger'),
    onClick: onClick,
    paddingInline: "200",
    type: "button",
    use: "unstyled",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: I18n.text('learningCenter.faceNav.avatar'),
        blockSize: "28px",
        responsive: true,
        shape: "circle",
        src: avatarUrl || defaultAvatar
      }), !breakpointName && /*#__PURE__*/_jsx(Text, {
        color: "text-core-on-fill-default",
        paddingInline: "200",
        whiteSpace: "nowrap",
        children: name
      }), /*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-on-fill-default",
        icon: DownIcon,
        size: "100"
      })]
    })
  });
};